import { Box, styled } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  maxWidth: '80em',
  marginBlock: theme.spacing(3),
  marginInline: 'auto',
  padding: theme.spacing(0, 3),
}));

export const ExampleBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  border: `1px dashed ${theme.palette.grey[500]}`,
  maring: 0,
  marginBottom: theme.spacing(5),
  display: 'flex',
  gap: theme.spacing(1),
}));

export const ExampleBoxSmall = styled(ExampleBox)({ maxWidth: '30em' });

export const ExampleBoxLight = styled(ExampleBox)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
}));

export const ExampleBoxGrid = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  border: `1px dashed ${theme.palette.grey[500]}`,
  maring: 0,
  marginBottom: theme.spacing(5),
  display: 'flex',
  gap: theme.spacing(4),
}));

export const ExampleBoxLightGrid = styled(ExampleBoxGrid)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
}));
